import { toJS } from 'mobx';
import product from './store.product';
import locale from './store.locale';
import params, { CUR_DEFAULTS } from './store.params';
import files from './store.files';
import gdms from './store.gdms';

const store = {
  product,
  locale,
  params,
  files,
  gdms,
};

(window as any).__STORE__ = store;
(window as any).__TO_JS_ = toJS;

export default store;

type UseStore<T> = [T, (arg: T) => void, ...any[]];

/**
 * gdms
 */
export const useGdms = () => {
  return {
    gdmsToken: gdms.gdmsToken,
    gdmsCallback: gdms.gdmsCallback,
    isFromGdms: gdms.isFromGdms,
  };
};

/**
 * 语言
 */
export const useLocale = (): UseStore<Locale> => {
  return [locale.current, locale.updateLocale];
};

/**
 * 型号
 */
export const useProduct = (): UseStore<Product> => {
  return [product.current, product.setProduct];
};

/**
 * 时间戳，用于导入重载表单
 */

export const useTs = (): UseStore<number> => {
  return [product.ts, product.updateTs];
};

/**
 * 配置项
 */
export const useSettings = (): UseStore<ConfigSettings> => {
  return [params.settings, params.updateSettings, CUR_DEFAULTS.settings];
};

export const usePhonebook = (): UseStore<ConfigPhonebook> => {
  return [params.phonebook, params.updatePhonebook, CUR_DEFAULTS.phonebook];
};

export const useBackground = (): UseStore<ConfigBackground> => {
  return [params.background, params.updateBackground, CUR_DEFAULTS.background];
};

export const useCallset = (): UseStore<ConfigCallset> => {
  return [params.callset, params.updateCallset, CUR_DEFAULTS.callset];
};

export const useScreensaver = (): UseStore<ConfigScreensaver> => {
  return [
    params.screensaver,
    params.updateScreensaver,
    CUR_DEFAULTS.screensaver,
  ];
};

export const useLanguage = (): UseStore<ConfigLanguge> => {
  return [params.language, params.updateLanguge, CUR_DEFAULTS.language];
};

export const useTaskbar = (): UseStore<ConfigTaskbar> => {
  return [params.taskbar, params.updateTaskbar, CUR_DEFAULTS.taskbar];
};

export const useFitscreen = (): UseStore<ConfigFitScreen> => {
  return [params.fitscreen, params.updateFitscreen, CUR_DEFAULTS.fitscreen];
};

export const useMenu = (): UseStore<ConfigMenu> => {
  return [params.menu, params.updateMenu, CUR_DEFAULTS.menu];
};

export const useUpdateThirdAppParams = () => {
  return store.params.updateThirdAppParam;
};

export const useLayout = (): UseStore<ConfigLayout> => {
  return [params.layout, params.updateLayout, CUR_DEFAULTS.layout];
};

export const useLayoutApp = (): UseStore<PropType<ConfigLayout, 'app'>> => {
  return [params.layout.app, params.updateLayoutApp];
};

export const useLayoutWidget = (): UseStore<
  PropType<ConfigLayout, 'widget'>
> => {
  return [params.layout.widget, params.updateLayoutWidget];
};

export const useLayoutSider = (): UseStore<PropType<ConfigLayout, 'sider'>> => {
  return [params.layout.sider, params.updateLayoutSider];
};

export const useLayoutFolder = (): UseStore<
  PropType<ConfigLayout, 'folder'>
> => {
  return [params.layout.folder, params.updateLayoutFolder];
};

export const useLayoutShortcut = (): UseStore<
  PropType<ConfigLayout, 'shortcut'>
> => {
  return [params.layout.shortcut, params.updateLayoutShortcut];
};

export const useDesktop = (): UseStore<ConfigDesktop> => {
  return [params.desktop, params.updateDesktop, CUR_DEFAULTS.desktop];
};

/**
 * 各种上传文件
 */
export const useLocalImg = (): UseStore<FileOrNull> => {
  return [files.localImg, files.setLocalImg];
};

export const useCustomInput = (): UseStore<FileOrNull> => {
  return [files.customInput, files.setCustomInput];
};

export const useCustomLang = (): UseStore<FileOrNull> => {
  return [files.customLang, files.setCustomLang];
};

export const useBgImg = (): UseStore<FileOrNull> => {
  return [files.bgImg, files.setBgImg];
};

export const useThirdApp = (): UseStore<File[]> => {
  return [files.thirdApp, files.setThirdApp];
};
